import { render, staticRenderFns } from "./r-reminder-panel.vue?vue&type=template&id=2f7d27d4"
import script from "./r-reminder-panel.vue?vue&type=script&lang=js"
export * from "./r-reminder-panel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f7d27d4')) {
      api.createRecord('2f7d27d4', component.options)
    } else {
      api.reload('2f7d27d4', component.options)
    }
    module.hot.accept("./r-reminder-panel.vue?vue&type=template&id=2f7d27d4", function () {
      api.rerender('2f7d27d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/reminder/r-reminder-panel.vue"
export default component.exports